import { TextField, withStyles, makeStyles } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import background from "./../../assets/images/Backgound-IMG_xmall.jpg";

export const StyledTextField = withStyles((theme) => ({
  root: {
    "& .MuiInputLabel-formControl": {
      color: theme.custom.color.blackRussian,
      opacity: 0.4,
    },
    "& .MuiInputLabel-formControl .MuiInputLabel-asterisk": {
      display: "none",
    },
    "& .MuiInputLabel-formControl.Mui-focused": {
      color: theme.palette.primary.main,
      opacity: 1,
    },
    "& .MuiInputBase-root:before": {
      borderColor: theme.custom.color.gainsboro,
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderColor: theme.custom.color.gainsboro,
    },
  },
}))(TextField);

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
  },
  image: {
    backgroundImage: `url('${background}')`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-start",
  },
  main: {
    marginTop: "auto",
    marginBottom: theme.spacing(2),
  },
  footer: {
    padding: theme.spacing(5, 2),
    marginTop: "auto",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[800],
  },
  title: {
    marginBottom: theme.spacing(6),
  },
  paper: {
    padding: theme.spacing(8, 2),
    maxWidth: "432px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
  },
  thumb: {
    maxWidth: "400px",
    marginBottom: theme.spacing(3),
  },
  thumbImg: {
    width: "100%",
    objectFit: "contain",
    objectPosition: "center center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  resetPswd: {
    fontSize: "16px",
    letterSpacing: "0.5px",
    lineHeight: "22px",
    display: "inline-flex",
    justifyContent: "flex-end",
    color: theme.palette.primary.main,
    margin: theme.spacing(3, 0, 6, 0),
    textDecoration: "none",
  },
  submit: {
    margin: theme.spacing(8, 0, 2),
    padding: theme.spacing(1.5, 2),
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  listWrapper: {
    display: "flex",
  },
  list: {
    listStyle: "none",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: theme.spacing(0, 0, 2, 0),
    paddingLeft: theme.spacing(2),
  },
  listItem: {
    display: "flex",
    padding: theme.spacing(2, 4),
  },
  listItemLogo: {
    maxWidth: "133px",
    width: "100%",
    objectFit: "contain",
    objectPosition: "center center",
  },
  secondaryLink: {
    color: theme.palette.background.default,
    fontWeight: 600,
    fontSize: "16px",
    letterSpacing: "normal",
    lineHeight: "22px",
  },
  alert: {
    "& .MuiAlert-message": {
      color: theme.palette.error.main,
    },
  },
}));
